export default __webpack_public_path__ + "static/media/icons2.6c742f70.svg";